import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { FC, useCallback } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import Modal from '../Modal';
import Autocomplete from '../forms/Autocomplete';
import ButtonLoadingIcon from '../forms/ButtonLoadingIcon';
import FormGrid from '../forms/FormGrid';
import FormStack from '../forms/FormStack';
import DetailedSheetStatusesEnum from '../../enums/detailed-sheets/detailed-sheet-statuses.enum';
import OptionInterface from '../../interfaces/option.interface';
import DetailedSheetsFiltersFieldValuesInterface from '../../interfaces/detailed-sheets/detailed-sheets-filters-field-values.interface';
import {
  onInvalidSubmit,
  validateArrayRequired,
} from '../../utils/validations';

const { CANCELED, APPROVED, INCOMPLETE, PROCESSING } =
  DetailedSheetStatusesEnum;

const DETAILED_SHEET_STATUSES_OPTIONS: OptionInterface[] = [
  {
    label: 'Approuvé',
    value: APPROVED,
  },
  {
    label: 'En traitement',
    value: PROCESSING,
  },
  { label: 'Incomplet', value: INCOMPLETE },
  { label: 'Annulé', value: CANCELED },
];

interface Props {
  opened: boolean;
  detailedSheetStatuses: DetailedSheetStatusesEnum[];
  onClose: () => void;
  onDetailedSheetStatusesChange: (
    detailedSheetStatuses: DetailedSheetStatusesEnum[],
  ) => void;
}

const DetailedSheetsDataTableFiltersModal: FC<Props> = ({
  onClose,
  onDetailedSheetStatusesChange,
  opened,
  detailedSheetStatuses,
}) => {
  const {
    control,
    formState: { isSubmitting },
    handleSubmit,
  } = useForm<DetailedSheetsFiltersFieldValuesInterface>({
    defaultValues: {
      detailedSheetStatuses,
    },
  });

  const onSubmit: SubmitHandler<DetailedSheetsFiltersFieldValuesInterface> =
    useCallback(
      (fieldValues) => {
        onDetailedSheetStatusesChange(fieldValues.detailedSheetStatuses);
        onClose();
      },
      [onClose, onDetailedSheetStatusesChange],
    );

  return (
    <Modal open={opened} onClose={onClose}>
      <form onSubmit={handleSubmit(onSubmit, onInvalidSubmit)}>
        <FormStack>
          <FormGrid>
            <Grid item xs={12}>
              <Typography variant="overline" component="h2">
                Filtres avancés
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Autocomplete
                control={control}
                label="Statuts"
                name="detailedSheetStatuses"
                options={DETAILED_SHEET_STATUSES_OPTIONS}
                rules={validateArrayRequired()}
                fullWidth
              />
            </Grid>
          </FormGrid>
        </FormStack>

        <Button
          disabled={isSubmitting}
          type="submit"
          variant="contained"
          sx={{ float: 'right' }}
          startIcon={isSubmitting && <ButtonLoadingIcon />}
        >
          Filtrer
        </Button>
      </form>
    </Modal>
  );
};

export default DetailedSheetsDataTableFiltersModal;
